const Theme = {
  header_full_height: true,
  logo_image_url: 'aqualab.png',
  token_url: 'aqualab.png',
  number_hidden: true,

  button_text_uppercase: true,

  text_font: `'Open Sans', sans-serif`,
  title_font: `'Open Sans', sans-serif`,

  button_color: '#f3ad45',
}

export default Theme
